<svg class="indicator" height="100" width="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle class="circle" cx="50" cy="50" r="42.5"/>
    <path class="path"
          d="M38.1 9.19C41.88 8.09 45.87 7.5 50 7.5c23.47 0 42.5 19.03 42.5 42.5 0 19.97-13.78 36.73-32.35 41.28"/>
</svg>
